export const handleDisable = (input) => {
    return input.some((field) => field === "")
}